/*
** 侧边菜单栏
*/
import React, { Component } from 'react';
import { Layout, Menu, message  } from 'antd';
import '../index.css';

import { getUserInfo } from '../../../apis/api'

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

export default class SiderCustom extends Component{

    constructor(props){

        super(props);
        this.state = {
            access_token:'',
            menuList:[], //菜单列表
            selectedKey: '', //选择的路径
            openKey:'', //打开的路径（选择的上一层）
        }
    }

    componentWillMount() {


    }

    componentDidMount() {
        const {
            openKey, 
            selectedKey,
            access_token
        } = this.props;
       if(access_token){
       this.setState({
            access_token:access_token?access_token:sessionStorage.getItem('access_token'),
            selectedKey: selectedKey ? selectedKey : '0',
            openKey:openKey ? openKey: '0',
        },()=>{
            this.getUserInfo();
        })
        }
         
      }

    componentWillReceiveProps(nextProps) { 
        const {
            openKey, 
            selectedKey,
            access_token
        } = nextProps;
        
        if(selectedKey!==this.props.selectedKey){
            this.setState({ selectedKey : selectedKey ? selectedKey : '0' })
          }
          if(openKey!==this.props.openKey){
               
            this.setState({  openKey:openKey ? openKey: '0' })
            
          }
          if(access_token&&access_token!==this.props.access_token){
               
            this.setState({ access_token:access_token?access_token:sessionStorage.getItem('access_token')},()=>{
                this.getUserInfo();
            })
            
          }
      }

      getUserInfo(){

        let _this=this;
        let params={
          access_token:_this.state.access_token,
        }
        getUserInfo(params).then( (data)=> {
  
        if(data.code === 0){

          let menuList=data.content.menu_list;
          if(menuList.length){
            menuList.map(item=>{
                if(item.child.length){
                    let flag=item.child.every(itm=>itm.type===3);
                    if(flag){
                        item.child=[];
                    }
                    item.child.map(itm=>{
                        if(itm.child.length){
                            let flag=itm.child.every(i=>i.type===3);
                            if(flag){
                               itm.child=[];
                            }
                            itm.child.map(i=>{
                                i.child=[];
                                return i;
                            })
                        }
                        return itm;
                    })
                }
                return item;
            })
            _this.setState({ menuList })
          }
          
        }else{

            // message.error(data.message); 
        }
        });

      }

    //点击菜单项时执行的函数
    menuClick = (e,item) => {
        sessionStorage.setItem('key', e.key);

        this.setState({

            selectedKey: e.key,

        });
    };

    //subMenu展开关闭时执行的函数
    openMenu = v => {
        let key=v[v.length - 1],parentKey=v[v.length - 2],flag=false;
        let menuList=this.state.menuList;
      
        menuList&&menuList.length>0&&menuList.map(item=>{
            item.child&&item.child.length>0&&item.child.map(itm=>{
                 if(itm.uuid===key&&itm.parent_uuid===parentKey){
                    parentKey=itm.parent_uuid;
                    flag=true;
                 }
            })
        })
       
        this.setState({

            openKey : flag?key+','+parentKey:key,

        },()=>{

            console.log(this.state.openKey)
           
            sessionStorage.setItem('openKey', this.state.openKey);

        })
        
    };

    render(){

        const {
            menuList,
            openKey, 
            selectedKey,
            access_token,
        } = this.state;

        const menuItem = menuList.map((item)=>{
          if(item.type!==3){
            if(item.child&&item.child.length > 0){
                return(
                    <SubMenu
                        key={item.uuid}
                        title={
                            <div>
                                <img src={item.logo} className='iconfont' style={{width:18.8,height:16}} alt=""/>
                                {/* <img src={require("../../../static/images/nav_icon.svg")} className='iconfont' style={{width:18.8,height:16}} alt=""/> */}
                                {item.name}
                            </div>
                        }
                    >
                        {
                            item.child.map((child) =>{
                              if(child.type!==3){
                                if(child.child&&child.child.length > 0){
                                    return(
                                    <SubMenu
                                      key={child.uuid}
                                      title={child.name}
                                    >
                                        {child.child.map((secondChild)=>{
                                          if(secondChild.type!==3){
                                            return(
                                            <Menu.Item 
                                              key={secondChild.uuid} 
                                              title={secondChild.name}
                                            >
                                              <a className='third_item_menu' href={`${secondChild.redirect_url}?access_token=${access_token}&key=${selectedKey}&openKey=${openKey}&source=eimp`}>{secondChild.name}</a>
                                            </Menu.Item>)
                                          }
                                        })}
                                    </SubMenu>
                                    )
                                }else{
                                    return(
                                        <Menu.Item 
                                            key={child.uuid} 
                                            title={child.name}
                                        >
                                            <a href={`${child.redirect_url}?access_token=${access_token}&key=${selectedKey}&openKey=${openKey}&source=eimp`}>{child.name}</a>
                                        </Menu.Item>
                                    )
                                }
                              }
                            })
                        }
                    </SubMenu>
                )
            }else{

                return(
                    <Menu.Item 
                        key={item.uuid}
                        title={item.name}
                    >  
                           {/* <img src={item.icon} className='iconfont' style={{width:18.8,height:16}} alt=""/> */}
                           <a href={`${item.redirect_url}?access_token=${access_token}&key=${selectedKey}&openKey=${openKey}&source=eimp`}>
                               <img src={item.logo} className='iconfont' style={{width:18.8,height:16}} alt=""/>
                               {/* <img src={require("../../../static/images/nav_icon.svg")} className='iconfont' style={{width:18.8,height:16}} alt=""/> */}
                               {item.name}
                           </a>
                    </Menu.Item>
                )
            }
          }
        })

        return(
            <div className='menu_wrapper'>
            <Sider
                theme={"light"}
                trigger={null}
                width="240px"
            >
                <div 
                    className="sideBarTitle"
                    style={{
                        color:' #4D7CFE',
                        fontSize:'20px',
                        textAlign:'center',
                        fontWeight: 600,
                        letterSpacing: '2px',

                    }}
                >
                    <img src={require("../../../static/images/czy_logo.svg")} alt=''/>
                </div>
                <Menu
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    onClick={this.menuClick}
                    onOpenChange={this.openMenu}
                    openKeys={openKey?openKey.split(','):[]}
                    >
                    {menuItem}
                </Menu>
            </Sider>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/page/App/common/SiderCustom.jsx